__turbopack_context__.v({
  "responsive-align": "styles-module__YMXrpa__responsive-align",
});
